/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from 'react';
import { AppTextLabel } from "@@commons";

import './urlinputraw.less';

interface IUrlInputRaw {
    readOnly?: boolean;
    value: string;
    onUrlChange?: (value: string) => any;
    onValidUrlChange?: (isValid: boolean, url: string) => any;
    needCheckUrl?: boolean;
    instanceId?: string;
}

let urlInputRexExp: RegExp = null;

export const UrlInputRaw = ({ readOnly, value, onUrlChange, onValidUrlChange, needCheckUrl }: IUrlInputRaw) => {
    const [urlTyping, setUrlTyping] = useState('');
    const [warning, setWarning] = useState(false);

    // const style: any = {};
    // if (warning) { style.border = '1px solid red'; }

    const handleValidation = (url: string) => {
        let isValid = true;

        if (needCheckUrl) {
            if (urlInputRexExp == null) {
            // eslint-disable-next-line max-len
                const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,256}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)|(\{\{.+\}\})/gi;
                urlInputRexExp = new RegExp(expression);
            }
            isValid = !!url.match(urlInputRexExp);

            setWarning(url === '' ? false : !isValid);
        }

        return isValid;
    };

    useEffect(() => {
        setUrlTyping(value);
        handleValidation(value);
    }, [value]);

    return (
        <div className={'urlinputraw' + (warning ? ' error' : '')}>
            <input
                // style={style}
                type="url"
                value={urlTyping || value}
                readOnly={readOnly}
                placeholder="https://www.inwink.com"
                onChange={(arg) => {
                    const url: string = arg.currentTarget.value;
                    const isValid = handleValidation(url);
                    setUrlTyping(url);
                    if (onUrlChange) { onUrlChange(url); }
                    if (onValidUrlChange) { 
                        
                        onValidUrlChange(url === '' ? true : isValid, url); 
                    }
                }}
            />

            { warning && (
                <div className="entityform">
                    <div className="fielderror">
                        <AppTextLabel component="div" className="msg" i18n={"urlinput.warning"} />
                    </div>
                </div>
            ) }
        </div>
    );
};
